'use strict';

angular.module('TurneroApp').service('loginErrorService', [
    'seguridadService', '$window', '$log',
    function (seguridadService, $window, $log) {
        this.mostrar = function (error) {
            var proveedor = 'MiDocta';
            var campo = obtenerCampo(error);
            var mensaje = esErrorDeDatos(error)
                ? 'No pudimos completar el ingreso porque hay un problema con ' + (campo ? 'el dato "' + campo + '". Revisalo' : 'los datos personales registrados. Revisalos') + ' en ' + proveedor + ' y volvé a intentar. Si el problema continúa, comunicate con soporte.'
                : 'No pudimos validar tu sesión. Volvé a ingresar desde ' + proveedor + '. Si el problema continúa, comunicate con soporte.';
            seguridadService.logOut();
            try {
                $window.sessionStorage.removeItem('ngStorage-usuarioInfo');
            } catch (e) { }
            // No registrar el objeto HTTP: puede contener tokens, perfil o detalles de Oracle.
            $log.warn('No se pudo completar el ingreso al Turnero', {
                httpStatus: error && typeof error.status === 'number' ? error.status : null
            });
            swal({
                title: 'No pudimos iniciar sesión',
                text: mensaje,
                type: 'error',
                confirmButtonText: 'Aceptar',
                allowOutsideClick: false,
                allowEscapeKey: false
            });
            return mensaje;
        };

        function esErrorDeDatos(error) {
            var url = error && error.config && error.config.url;
            return typeof url === 'string' && url.toLowerCase().indexOf('post_usuario_vedi') !== -1;
        }

        function obtenerCampo(error) {
            var datos = error && error.data;
            var campo = datos && (datos.Campo || datos.campo);
            var camposPermitidos = {
                'Barrio': true,
                'Tel. celular': true,
                'Correo electrónico': true,
                'Nombre': true,
                'Apellido': true,
                'Calle': true,
                'Altura': true,
                'C.P.': true,
                'Foto personal': true,
                'Fecha de nacimiento': true
            };
            return camposPermitidos[campo] ? campo : null;
        }
    }
]);



// WEBPACK FOOTER //
// ./app/components/login/loginErrorService.js